import { CHECKR_SCREENINGS } from '@dadohr/shared/domainTypes/checkr';
import type { CheckrPackage } from '@dadohr/shared/domainTypes/checkr';

// Catalogue indexed by canonical key (the singular slug the package screening
// `type` uses, and the value stored on `storages[].source`).
const SCREENING_BY_KEY: Record<string, { additionalResults: string[] }> =
  Object.fromEntries(Object.values(CHECKR_SCREENINGS).map((s) => [s.key, s]));

/** Native sources: `<type>` or `<type>__<subtype>` (backend splits on `__`). */
export const screeningsToSources = (pkg: CheckrPackage): string[] =>
  pkg.screenings.map((s) => (s.subtype ? `${s.type}__${s.subtype}` : s.type));

/**
 * Native screenings plus each screening's related ("additional") screenings
 * from `CHECKR_SCREENINGS[].additionalResults` — the catalogue is the source of
 * truth, so new relationships appear automatically. Stored sources are the
 * canonical catalogue keys (additionalResults already hold canonical keys).
 * Deduped by key: an additional result is skipped if the package already
 * includes that screening (regardless of subtype) or another screening already
 * offered it.
 */
export const buildScreeningSources = (pkg: CheckrPackage): string[] => {
  const sources = screeningsToSources(pkg);
  const offeredKeys = new Set(pkg.screenings.map((s) => s.type));
  for (const { type } of pkg.screenings) {
    for (const additional of SCREENING_BY_KEY[type]?.additionalResults ?? []) {
      if (offeredKeys.has(additional)) continue;
      offeredKeys.add(additional);
      sources.push(additional);
    }
  }
  return sources;
};
